import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { InputElement } from "../../shared/FormElements";
import { SiteConstants } from "../../../constants/constant";
import { appleSignInAuth } from "../../../util/commonFunctions";

const Login = props => {

  useEffect(() => {
    appleSignInAuth();
  });

  const handleEnterKey = event => {
    const eventCode = event.which || event.keyCode;
    if (eventCode === SiteConstants.ENTER_KEY_EVENT_CODE) {
      props.sucessHandler(props.formName);
    }
  };

  const signInStructure = props.form.map((value, index) => (
    <div
      key={value + index}
      className="d-flex justify-content-center  no-gutter"
    >
      <InputElement
        name={value.id}
        type={value.config.type}
        class="mb-3 col-12 form-group mt-20"
        label={value.config.label}
        required={value.config.validation.require}
        value={value.config.value}
        onChangeHandler={props.onChangeHandler}
        formName={props.formName}
        onBlurHandler={props.onBlurHandler}
        errorMsg={value.config.errorMsg}
        valid={value.config.valid}
        maxLength={value.config.maxLength}
      />
    </div>
  ));
  return (
    <React.Fragment>
      {props.sucessState ? (
        window.location.href = localStorage.getItem("userLastKnownLocation")
        // <Redirect to={localStorage.getItem("userLastKnownLocation")} />
      ) : (
        <form onSubmit={() => handleEnterKey()}>
          <div className="border-bottom-0 text-center signInRelative">
            {props.message && <p className="error">{props.message}</p>}
            <h3>Sign in</h3>
            <p>Sign in to your ausbiz account</p>
            <a
              className="googleBtn btn"
              href="/google"
            >
              <div className="signup_icon">
                <img src="/assets/svg/logoGoogle_new.svg" alt="linkedin" />
              </div>
              <span>Continue with Google</span>
            </a>
            <a href="/linkedin" className="linkedinBtn btn">
              <div className="signup_icon">
                <img src="/assets/svg/iconAppLinkedinBlue_new.svg" alt="linkedin" />
              </div>
              <span>Continue with Linkedin</span>
            </a>
            <div className='shadow-apple-button' tabIndex={'0'}>
              <div className="signup_icon">
                <img src="../../../assets/svg/apple_new.svg" />
              </div>
              <span className="apple-text">Continue with Apple</span>
            </div>
            <div className={'apple-sign-in'}
              id="appleid-signin" data-color="white" data-border="true" data-type="continue" />
            <div className="orClass">OR</div>
          </div>

          <div>{signInStructure}</div>

          <div className="border-top-0">
            {/* <a href="javascript:void(0)" className="forgot">
              Forgot your password?
            </a> */}
            <a href="/resetpassword" className="forgot">
              Forgot your password?
            </a>
            <button
              type="submit"
              className={
                props.btnDisabled ? "btn continue" : "btn continue active"
              }
              disabled={props.btnDisabled ? "disabled" : ""}
              onClick={() => props.sucessHandler(props.formName)}
              onKeyPress={event => handleEnterKey(event)}
            >
              Sign in
            </button>
            <p className="text-center noAccount">
              Don’t have an account?
              <a href="javascript:void(null);" onClick={() => props.changeFormHandler('signup')} className="link">
                &nbsp;&nbsp;Sign up for free
              </a>
            </p>
          </div>
        </form>
      )}
    </React.Fragment>
  );
};

export default withRouter(Login);
